import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router";

function AttendancePolicy() {

  return (
     <Box sx={{width:"100%"}}>
        <Outlet/>
     </Box>
      
  );
}

export default AttendancePolicy;
